export const HEATMAP_COLOR_MAPS = ['classic', 'greenRed', 'blueRed', 'heat', 'mono', 'redIntensity', 'original'] as const;
export type HeatmapColorMap = (typeof HEATMAP_COLOR_MAPS)[number];
